import TabStore from "./tabStore";
const stores = {
  TabStore
};

export { stores };
export default stores;
